<template>
  <combobox-filter2000
    class="mb-0 pb-0"
    v-model="selectedStatusesVal"
    :label="this.$t('cards.cardStatuses')"
    :items="allStatuses"
    itemText="statusName"
    itemValue="cardStatusId"
    :translate="true"
    :localizationFunc="
      (value) => {
        return this.$t('CardStatusNames.' + value.statusName);
      }
    "
    :prepend-icon="'mdi-state-machine'"
    style="z-index: 1000"
    :prependStatuses="true"
    :prependIcon="'mdi-check-all'"
    :prependTextSelectAll="$t('Statuses.SelectAll')"
  />
</template>

<script>
import ComboboxFilter2000 from '@/components/FiltersComponent/ComboboxFilter2000';

export default {
  components: {
    ComboboxFilter2000,
  },
  props: ['selectedStatuses'],
  model: {
    prop: 'selectedStatuses',
    event: 'selectedStatusesEv',
  },
  data() {
    return {
      selectedStatusesVal: [],
      allStatuses: [],
    };
  },
  watch: {
    selectedStatuses() {
      this.selectedStatusesVal = this.selectedStatuses;
    },
    selectedStatusesVal() {
      this.$emit('selectedStatusesEv', this.selectedStatusesVal);
    },
  },
  mounted() {
    this.getAllStatuses();
  },
  methods: {
    getAllStatuses() {
      try {
        this.$axios.cardStatuses
          .getArchive()
          .then((response) => response.data)
          .then((json) => (this.allStatuses = json))
          .catch((err) => console.error(err));
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
